<template>
  <div>
    <form
      ref="form"
      id="form_id"
      class="row g-3 needs-validation"
      novalidate
      @submit.prevent="check"
    >
      <div
        class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <div class="row">
          <div class="col-10">
            <h1 class="h2 text-muted">ADMINISTRATION / ADD USER</h1>
          </div>

          <div class="col-1">
            <button
              type="button"
              class="btn btn-danger"
              id="disbut"
              @click="discard"
            >
              Discard
            </button>
          </div>
          <div class="col-1">
            <button class="btn btn-primary" type="submit" id="savebut">
              Save
            </button>
          </div>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger" role="alert">
        Error: {{ reason }}
      </div>
      <div class="col-md-7">
        <label for="fullname" class="form-label">Full Name</label>
        <input
          class="form-control"
          id="fullname"
          v-model="full_name"
          autocomplete="nope"
          required
        />
        <div class="invalid-feedback">
          Full Name is required!
        </div>
      </div>
      <div class="col-md-5">
        <label for="inputPassword4" class="form-label">Account Name</label>
        <input
          class="form-control"
          id="accname"
          v-model="account_name"
          autocomplete="nope"
          required
        />
        <div class="invalid-feedback">
          Account Name is required!
        </div>
      </div>
      <div class="col-md-7">
        <label for="loginname" class="form-label">Username</label>
        <input
          class="form-control"
          id="loginname"
          v-model="username"
          autocomplete="nope"
          required
        />
        <div class="invalid-feedback">
          Username is required!
        </div>
      </div>
      <div class="col-md-5">
        <label for="secret" class="form-label">Key</label>
        <!-- <input class="form-control" id="key" disabled v-model="key" /> -->
        <div class="input-group mb-2">
          <input
            type="text"
            class="form-control"
            id="key"
            v-model="key"
            readonly
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="generateKey"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-arrow-clockwise"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
              />
              <path
                d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
              />
            </svg>
          </button>
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="copySecret"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-clipboard"
              viewBox="0 0 16 16"
            >
              <path
                d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
              />
              <path
                d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="col-md-7">
        <label for="email" class="form-label">Email</label>
        <input
          class="form-control"
          id="email"
          v-model="email"
          autocomplete="nope"
          required
        />
        <div class="invalid-feedback">
          Email is required!
        </div>
      </div>

      <div class="col-md-7 mb-3">
        <label for="password" class="form-label">Password</label>
        <input
          type="password"
          class="form-control"
          id="password"
          v-model="password"
          required
        />
        <div class="invalid-feedback">
          Password is required!
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="active"
            value="active"
            v-model="active"
            required
          />
          <label class="form-check-label" for="active">
            Account Active
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="disabled"
            value="disabled"
            v-model="active"
            required
          />
          <label class="form-check-label" for="disabled">
            Account Disabled
          </label>
          <div class="invalid-feedback">
            Account Type is required!
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config";
export default {
  data() {
    return {
      full_name: "",
      username: "",
      email: "",
      active: "",
      password: "",
      account_name: "",
      key: "",
      error: false,
      reason: "",
    };
  },
  methods: {
    async check() {
      const form = document.getElementById("form_id");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              full_name: this.full_name,
              username: this.username,
              email: this.email,
              password: this.password,
              active: this.isActive(),
              account_name: this.account_name,
              key: this.key,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/add_user",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) this.$router.push("/users");
        else {
          this.error = true;
          this.reason = data["reason"];
        }
      }
      // var forms = document.querySelectorAll(".needs-validation");

      // Loop over them and prevent submission
      // Array.prototype.slice.call(forms).forEach(function(form) {

      // });
    },
    async generateKey() {
      const res = await axios.get(config.baseURL + "/generate_secret_code");
      console.log(res.data["secret_code"]);
      this.key = res.data["secret_code"];
    },
    copySecret() {
      var copyText = document.getElementById("key");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      // alert("Successfully copied secret token!");
    },
    isActive() {
      if (this.active === "active") {
        return true;
      } else {
        return false;
      }
    },
    discard() {
      this.$router.push("/users");
    },
  },
  mounted() {
    this.generateKey();
    const form = document.getElementById("form_id");
    form.addEventListener(
      "submit",
      function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
  },
};
</script>

<style scoped></style>
